import api from '../api';
import { useRequestImmer } from '../api/hooks';
import { ID } from '../global';
import { Page } from './common';
import { BalanceLog } from './poiConfig';
import { TransactionLog, TransactionLogRefundInfo } from './transaction';

const BalanceEndpoint = `/balance`;

export const requestUserBalanceLogList = () =>
  useRequestImmer<{ list: BalanceLog[]; page: Page }>(
    {
      url: `${BalanceEndpoint}/log/{userId}`,
      method: 'get',
    },
    {
      manual: true,
    }
  );

export interface BalanceRefundInfo {
  refundMethod: number;
  balance: number;
  totalRechargeAmount: number;
  totalConsumeAmount: number;
  totalRefundedAmount: number;
  maxRefundableAmount: number;
  maxMerchantRefundAmount: number;
  maxUserRefundAmount: number;
  rechargeTransactionLogs: TransactionLogRefundInfo[];
}

export const balanceRefundCalc = async (userId: ID) => {
  return (await api.get({
    url: `${BalanceEndpoint}/refund/calc`,
    params: { userId },
  })) as BalanceRefundInfo;
};

export const useRefundBalance = () => {
  const { send, ...rest } = useRequestImmer<TransactionLog[]>(
    {
      url: `${BalanceEndpoint}/refund`,
      method: 'post',
    },
    {
      manual: true,
    }
  );
  return {
    ...rest,
    send: (data: {
      userId: ID;
      // 退款类型: 1-商家 2:-客户 3:协商
      method: number;
      refundAmount: number;
      balanceAmount: number;
    }) => send({ data }),
  };
};

export const balanceRefund = async (data: {
  userId: ID;
  // 退款类型: 1-商家 2:-客户 3:协商
  method: number;
  refundAmount: number;
  balanceAmount: number;
}) => {
  return (await api.post({
    url: `${BalanceEndpoint}/refund/calc`,
    data,
  })) as BalanceRefundInfo;
};

export const adjustmentBalance = async ({
  userId,
  amount,
  type,
  comment,
}: {
  userId: ID;
  amount: BigNumber;
  type: number;
  comment?: string;
}) => {
  return (await api.post<number>({
    url: `${BalanceEndpoint}/adjustment/plus`,
    data: {
      userId,
      type,
      comment,
      amount,
    },
  })) as number;
};
